class AccountSettings.OperatorStatusListView extends Backbone.View
  templateHeader: JST["backbone/templates/account_settings/operator_statuses/list"]
  templateRow: JST["backbone/templates/account_settings/operator_statuses/row"]

  initialize: (@options = {}) ->
    @collection = @options.collection
    @null_operator_name = @options.null_operator_name
    @offline_unassign_tickets = @options.offline_unassign_tickets
    @null_unassign_tickets = @options.null_unassign_tickets
    @render()
    @collection.on('all', @_renderList)

  render: ->
    @$el.html(@templateHeader({
      self: @,
      null_operator_name: @null_operator_name,
      offline_unassign_tickets: @offline_unassign_tickets,
      null_unassign_tickets: @null_unassign_tickets
    }))
    @tbody = @$el.find('tbody')
    @_renderList()
    @_makeItSortable()
    @

  _renderList: =>
    @tbody.empty()
    _.each @collection.models, (mod) =>
      row = $(@templateRow({
        self: @,
        model: mod,
        offline_unassign_tickets: @offline_unassign_tickets,
        null_unassign_tickets: @null_unassign_tickets
      }))
      @tbody.append(row)

  _makeItSortable: ->
    @tbody.sortable({
      axis: 'y',
      cursor: 'move',
      helper:  @_getResizeFunction(),
      start: (e, ui) => $(ui.item).attr('data-previndex', ui.item.index())
      update: ((event, ui) =>
        newIndex = ui.item.index();
        oldIndex = $(ui.item).attr('data-previndex');
        $(ui.item).removeAttr('data-previndex');
        @collection.updatePositions(oldIndex, newIndex))
    })
    @tbody.disableSelection()

  _getResizeFunction: ->
    (e, ui) ->
      ui.children().each ->
        $(this).width($(this).width());
      return ui;

  # Duplicated with response_template/response_template_list_view.js.coffee
  setLocale: ->   # I don't know why, but if I don't set the locale again, the template list.jst.ejs is not translated
    userLanguage = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage
    userLanguage = userLanguage.split('-')[0]
    I18n.locale = if userLanguage in ['en', 'es', 'pt'] then userLanguage else 'en'
